import { render, staticRenderFns } from "./StockPlace.vue?vue&type=template&id=0fa8eff6&scoped=true&"
import script from "./StockPlace.vue?vue&type=script&lang=js&"
export * from "./StockPlace.vue?vue&type=script&lang=js&"
import style0 from "./StockPlace.vue?vue&type=style&index=0&id=0fa8eff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa8eff6",
  null
  
)

export default component.exports